import { Fraga } from "@/types/riskbedomning";

export const etableringOrganisationFragor: Fraga[] = [
  {
    id: "etablering-utrymmen-sammansatt",
    text: "Riskerar etablering, utrymmen eller arbetsplatsorganisation att vara bristfälliga ur arbetsmiljösynpunkt?",
    kategori: "Etablering & arbetsplatsorganisation",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar etableringen att sakna tillräckligt utrymme för hela byggperioden?",
      "Riskerar arbetsmoment, materialhantering och tillträdesleder att sakna tillräckliga ytor?",
      "Finns risk att miljöfarligt avfall inte kan hanteras korrekt p.g.a. platsbrist?",
      "Riskerar tidiga arbetsmoment att sakna tillgång till vatten och hygienutrymmen?",
      "Kan otillräcklig belysning, nödbelysning eller reservbelysning på etablerade ytor skapa risk för olyckor, snubbel eller svårigheter vid evakuering?",
      "Kan avsaknad av projekterade nivåer eller felaktig placering av gångvägar och utrymningsvägar skapa risker vid förflyttning eller evakuering?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "transport-logistik-sammansatt",
    text: "Riskerar transportlogistik eller interntrafik att vara bristfälligt organiserad ur säkerhetssynpunkt?",
    kategori: "Etablering & arbetsplatsorganisation",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar större transporter eller montage att genomföras utan fastställd transport- eller lyftplan?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "vader-yttre-forhallanden",
    text: "Kan väder och yttre förhållanden skapa risker för säkerheten?",
    kategori: "Etablering & arbetsplatsorganisation",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att regn eller snö gör arbetsytor hala?",
      "Riskerar snö- och ishantering på byggarbetsplatsen att vara otillräckligt planerad eller utförd?",
      "Behöver arbetsmoment skjutas upp vid särskilt dåliga väderförhållanden?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "boende-djur-omgivning",
    text: "Riskerar arbetet att medföra störningar för närboende eller andra omgivningsrisker?",
    kategori: "Etablering & arbetsplatsorganisation",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att närboende exponeras för säkerhetsrisker från arbetsplatsen?",
      "Finns det risk att information till boende om arbetet är bristfällig?",
      "Finns det risk att skyddsbarriärer mot bostadsområden saknas eller är otillräckliga?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  }
];
